export default "__VITE_ASSET__8af52596__"